<script context="module" lang="ts">
  export type Look = {
    markers?: {
      details?: Array<{ x?: number; y?: number; title?: string }>;
      image?: { src?: string; alt?: string };
    };
    products?: { handle?: string; link?: string | MultilinkStoryblok }[];
    use_markers_with_following_image?: boolean;
    video?: AssetStoryblok;
    image?: string;
    name?: string;
    avatar?: AssetStoryblok;
    username?: string;
    date?: string;
    caption?: string;
    event_id: string;
  };
</script>

<script lang="ts">
  import { drawer } from '$lib/stores/drawer';
  import { cn } from '$lib/utils';
  import type { AssetStoryblok, MultilinkStoryblok } from '$types/bloks';
  import LookContent from './look-content.svelte';
  import LookDrawer from './look-drawer.svelte';
  import { getUUID } from '$lib/utils/uuid';
  import { createEventDispatcher } from 'svelte';
  import { analyticsEvent, AnalyticsEvents } from '$lib/analytics';

  let className: string | undefined = undefined;

  export { className as class };
  export let look: Look;
  export let showInProductsGrid: boolean | undefined = undefined;
  export let drawerId: string | undefined = undefined;

  const dispatch = createEventDispatcher<{ click: undefined }>();

  const internalDrawerId = drawerId ?? 'shop-the-look' + getUUID();

  export let index: number | undefined = undefined;
</script>

<!-- Card -->
<div class={cn(className, showInProductsGrid && 'h-full')}>
  <div
    class={cn(
      'group relative isolate flex cursor-pointer flex-col justify-between overflow-hidden rounded-[20px]',
      !showInProductsGrid && 'aspect-[2/3]',
      'h-full'
    )}
  >
    <LookContent
      {look}
      {showInProductsGrid}
      on:click={() => {
        if (internalDrawerId)
          drawer.open(internalDrawerId, {
            meta: {
              initialIndex: index
            }
          });
        dispatch('click');
        analyticsEvent({
          event: AnalyticsEvents.LOOK,
          id: look.event_id
        });
        analyticsEvent({
          event: AnalyticsEvents.LOOK_CLICK,
          id: look.event_id
        });
      }}
    />
  </div>
</div>

{#if !drawerId}
  <LookDrawer allLooks={[look]} drawerId={internalDrawerId} />
{/if}
